<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-title"><span>Contents</span></h1>
<p class="toc-chapter" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-chapter" id="toc-preface002"><a href="#/preface002">Prologue</a></p>
<p class="toc-part" id="toc-part001"><a href="#/part001">Part I</a></p>
<p class="toc-chapter" id="toc-chapter001"><a href="#/chapter001">Chapter 1</a></p>
<p class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">Chapter 2</a></p>
<p class="toc-chapter" id="toc-chapter003"><a href="#/chapter003">Chapter 3</a></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc-part" id="toc-part002"><span href="#/part002" title="Link target outside of Sample">Part II</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc-chapter" id="toc-chapter014"><span href="#/chapter014" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc-chapter" id="toc-chapter015"><span href="#/chapter015" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc-part" id="toc-part003"><span href="#/part003" title="Link target outside of Sample">Part III</span></p>
<p class="toc-chapter" id="toc-chapter016"><span href="#/chapter016" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toc-chapter" id="toc-chapter017"><span href="#/chapter017" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc-chapter" id="toc-chapter018"><span href="#/chapter018" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc-chapter" id="toc-chapter019"><span href="#/chapter019" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc-chapter" id="toc-chapter020"><span href="#/chapter020" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc-chapter" id="toc-chapter021"><span href="#/chapter021" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc-part" id="toc-part004"><span href="#/part004" title="Link target outside of Sample">Part IV</span></p>
<p class="toc-chapter" id="toc-chapter023"><span href="#/chapter023" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toc-chapter" id="toc-chapter024"><span href="#/chapter024" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc-chapter1" id="toc-appendix001"><span href="#/appendix001" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-chapter" id="toc-appendix003"><span href="#/appendix003" title="Link target outside of Sample">Author’s note</span></p>
<p class="toc-chapter" id="toc-appendix004"><span href="#/appendix004" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc-chapter"><span href="#/personblurb" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?df3a1a96